import { Scope } from './roles';

export type AreasData = Area[];
export type AppDefIdsData = string[];

export interface Area {
    title: string;
    scopes: Scope[];
}

export enum RestrictFromLevelType {
  SITE = 'site',
  ACCOUNT = 'account',
}

export type RestrictFromLevel = 'site' | 'account';

export type ScopeLevel = 'site' | 'account';

export interface AreaData {
   titleKey: string;
   restrictFromLevel?: RestrictFromLevel;
   appDefIds?: AppDefIdsData;
   scopes: ScopeData[];
}

export interface ScopeData {
    id: string;
    titleKey: string;
    descriptionKey: string;
    level: ScopeLevel;
    restrictFromLevel?: RestrictFromLevel;
    deprecated?: boolean;
    experiments?: string[];
    dependantScopes?: string[];
}
